export default __webpack_public_path__ + "static/media/Ahmed-CV.d77bd3d4.pdf";